import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const FullWidthSliceWrapper = styled.div``;

export const SliceWrapper = styled.div`
  max-width: ${theme.narrowWidth};
  margin: 0 auto;
  padding: 0 ${theme.spacing[4]};

  ${theme.largerThan.xl} {
    padding: 0;
  }
`;
